export default __webpack_public_path__ + "static/1276-87583e23936a48a342760a3505580b80.gif";